
<template>
  <div class="SettingsEditor">
    
    <form id="SettingsForm">

      <div class="submit-container">
        <button type="button" @click="saveSettings($event)">Save Settings</button>
        <span class="loading-status" :class="{'loading-status-faded': !loading}">
          <font-awesome-icon :icon="['fad', 'circle-notch']" spin></font-awesome-icon> 
        </span>
        <h1>Settings</h1>
      </div>

      <div class="settings-header-spacer"></div>

      <div class="sidebar">
        <a href="#" v-for="link in UI.sidebarLinks" @click="updateView(link, $event)" :class="{ selected: view(link) }" v-text="link"></a>
      </div>

      <div class="input-page" v-if="!Settings">
      <div class="input-page-inner">
        <span class="loading">
          <font-awesome-icon :icon="['far', 'circle-notch']" spin></font-awesome-icon> 
          &nbsp;Loading
        </span>
      </div>
      </div>

      <div class="input-page" v-if="Settings">
      <div class="input-page-inner">
      
          
        <div v-if="view('home')">
        
          <div class="input-group input-group-half-wide">

            <h2>Zone (<span v-text="instance.name"></span>)</h2>

            <hr />

            <h4>GUID</h4>
            <div class="input-container">
              <span v-if="libraryClient && libraryClient.Status.instances && libraryClient.Status.instances[instance.name]" v-text="libraryClient.Status.instances[instance.name].GUID"></span>
              <span v-else>
                <font-awesome-icon :icon="['far', 'circle-notch']" spin></font-awesome-icon> 
          &nbsp;Loading
              </span>
            </div>

            <h4>Channels</h4>

            <div class="input-container">
              <select v-if="Settings.audioServer && Settings.audioServer.instances && Settings.audioServer.instances[instance.name]" v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].channels" multiple>
                <option value="0">Left</option>
                <option value="1">Right</option>
              </select>
              <p class="help-text">To select multiple channels, hold <b>ctrl</b> key on PC, or <b>command</b> key on Mac.</p>
            </div>

            <div class="input-container">
              <button class="button-small" type="button" @click="saveAudioServerChannels()">Apply Channels</button>
              <p class="help-text">Click this to apply the channel settings.</p>
            </div>

            <!--

            <h4>Day Start Time</h4>
            
            <div class="input-container">
              <select v-if="Settings.timeline.offsetHour"  v-model="Settings.timeline.offsetHour">
                <option value="0">Midnight</option>
                <option value="1">1:00AM</option>
                <option value="2">2:00AM</option>
                <option value="3">3:00AM</option>
                <option value="4">4:00AM</option>
                <option value="5">5:00AM</option>
                <option value="6">6:00AM</option>
                <option value="7">7:00AM</option>
                <option value="8">8:00AM</option>
              </select>
            </div>
            -->

          </div>

          <div class="input-group input-group-half-wide">

            <h2>Status</h2>

            <section>
              <h4>Version</h4>
              <p>Interface: <b>0.9.1</b></p>
              <p>Audio Server: <b>0.9.0</b></p>
              <p>Automation Server: <b>0.9.2</b></p>
            </section>

            <section>
              <h4>Uptime</h4>
              <div v-if="systemStatus && systemStatus.uptime">
                <p>Device: <b v-text="systemStatus.uptime.system"></b></p>
                <p>Audio Server: <b v-text="systemStatus.uptime.audioServer"></b></p>
                <p>Automation Server: <b v-text="systemStatus.uptime.automationServer"></b></p>
                
                <!-- TODO: How long music has been continuous without a gap. -->
                <!-- <p>Music:</p> -->

              </div>
            </section>

            <section>
              <h4>Drive</h4>
              <div v-if="systemStatus && systemStatus.disk">
                <p>Total Drive Size: <b v-text="bytesToSize(systemStatus.disk.total)"></b></p>
                <p>Available: <b v-text="bytesToSize(systemStatus.disk.available)"></b></p>
                <!-- <p>Free: <b v-text="bytesToSize(systemStatus.disk.free)"></b></p> -->
              </div>
            </section>

              <!-- 
            <section>
              <h4>Last Error</h4>
              <p></p>
                <p>(See Loggly for last error.)</p> 
            </section>
              -->
            
          </div>

        </div>

        <!-- ================================================ -->

        <div class="input-group" v-if="view('restart')">

          <h2>Restart</h2>

          <div class="input-container">
            <button class="button-small" type="button" @click="rebootDevice()">Reboot Device</button>
            <div class="help-text">Reboot the device itself.</div>
          </div>
        
        </div>

        <!-- ================================================ -->

        <div class="input-group" v-if="view('library')">

          <h2>Media Library</h2>

          <hr>

          <div class="input-container">
          
            Library Location: <b v-if="Settings.instances && Settings.instances[instance.name] && Settings.instances[instance.name].library" v-text="Settings.instances[instance.name].library.path"></b>

          </div>

          <div class="input-container">
            

            Fallbacks Location: <b v-if="Settings.instances && Settings.instances[instance.name] && Settings.instances[instance.name].library" v-text="Settings.instances[instance.name].auto.fallbacks.path"></b>


          </div>

          <hr>

          <h3>Scan Audio Files</h3>

          <div class="input-container">
            <button class="button-small" type="button" @click="scanLibraryFast()">Start Quick Scan</button>
            <div class="help-text">Scans carts, fallbacks, and songs on playlists for today and tomorrow.</div>
          </div>
          
          <div class="input-container">
            <button class="button-small" type="button" @click="scanLibrary()">Scan Full Library</button>
            <div class="help-text">Scan every audio file in the Library folder above, including files in any subfolders.</div>
          </div>

        </div>

        <div class="input-group" v-if="view('playlists')">

          <h2>Playlists</h2>

          <hr>

          <div class="input-container">
            
            <!-- 
            <label>Playlists Location</label>
            <br>
            <br>
              <input type="text" style="width:100%" v-if="Settings.instances && Settings.instances[instance.name]" v-model="Settings.instances && Settings.instances[instance.name].playlists.path"  /> 
            -->

            Playlists Location: <b v-if="Settings.instances && Settings.instances[instance.name] && Settings.instances[instance.name].playlists" v-text="Settings.instances[instance.name].playlists.path"></b>


            <!--
            <div class="input-container">
              <button class="button-small" type="button" @click="ambiatorRunHourlyDebug()">Download Playlists</button>
              <div class="help-text">Downloads M3U playlists for today for this instance. After downloading, rebuild this day to update playlists in Timeline.</div>
            </div>            
            -->
          
          </div>

          <hr>

          <h3>Timeline</h3>


          <div class="input-container">
            <button class="button-small" type="button" @click="refreshTimeline()">Refresh Timeline</button>
            <div class="help-text">Normally, the timeline is auto-refreshed whenever an audio file finishes playing. However, this button will instantly refresh the timeline (reloading the current date). Useful if you want to quickly see any database changes (like newly-scanned playlists and music).</div>
          </div>

          <h3>Scan Playlists</h3>

          <div class="input-container">
            <button class="button-small" type="button" @click="playlistsScanToday()">Force Playlist Scan</button>
            <div class="help-text">Normally, playlists are automatically scanned if their M3U files change. However, if needed, this button will force today's playlists to be scanned. Useful if the auto-scan is interrupted somehow.</div>
          </div>
          <!-- <p>To scan playlists, click the date selector, then click <b>Scan</b>.</p> -->

          <!--
          TODO: You should only be able to scan today's playlists, else it could wipe out a LOT (months, years) of playlists in the DB.
          <div class="input-container">
            <button class="button-small" type="button" @click="scanPlaylists()">Scan Playlists</button>
          </div>
          -->

          <hr>

          <h3>Song History</h3>

          <div class="input-container">
            <input class="block" type="text" v-model="songHistoryDate" placeholder="Date (Format: YYYY-MM-DD)"/>
          </div>

          <div class="input-container">
            
            <button class="button-small" type="button" @click="getSongHistoryForDay()">Get Song History</button>

            <div class="help-text">Retrieves a list of songs for a specific date.</div>

            <ul>
              <li v-if="songHistoryList" v-for="song in songHistoryList">
                <span v-text="$moment.utc(song.created_at).tz(instance.status.time.timezone).format('HH:mm:ss')"></span> &mdash; 
                <b v-text="song.artist"></b> -
                <i v-text="song.title"></i>
              </li>
              <li v-else>No songs retrieved.</li>
            </ul>

          </div>

        </div>

        <!-- ================================================ -->

        <div class="input-group" id="SettingsCompressor" v-if="view('compressor')">

          <h2>Compressor</h2>

          <div v-if="Settings.audioServer && Settings.audioServer.instances && Settings.audioServer.instances[instance.name] && Settings.audioServer.instances[instance.name].outputs['device-1'] && Settings.audioServer.instances[instance.name].outputs['device-1'].compressor">

            <div class="input-container">
              <label>Attack time (ms)</label>
              <input type="text" v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].compressor.attackTime" />
              <div class="help-text">The attack time in milliseconds.</div>
            </div>

            <div class="input-container">
              <label>Auto Makeup Gain</label>
              <select v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].compressor.autoMakeupGain">
                <option :value="true">On</option>
                <option :value="false">Off</option>
              </select>
              <div class="help-text">Whether the compressor applies automatic gain makeup or not.</div>
            </div>

            <div class="input-container">
              <label>Knee Hardness</label>
              <input type="text" v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].compressor.kneeHardness" />
              <div class="help-text">Compression curve knee hardness. 0.0 is a very soft curve, 1.0 is a completely hard knee.</div>
            </div>

            <div class="input-container">
              <label>Link Channels</label>
              <select v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].compressor.linkChannels">
                <option :value="true">On</option>
                <option :value="false">Off</option>
              </select>
              <div class="help-text">Links the left and right channels together when "on". When "off" it functions as two mono compressors.</div>
            </div>

            <div class="input-container">
              <label>Output Gain</label>
              <input type="text" v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].compressor.outputGain" />
              <div class="help-text">Output gain in dB.</div>
            </div>

            <div class="input-container">
              <label>Ratio</label>
              <input type="text" v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].compressor.ratio" />
              <div class="help-text">The compression ratio, expressed as dB:1</div>
            </div>

            <div class="input-container">
              <label>Release Time</label>
              <input type="text" v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].compressor.releaseTime" />
              <div class="help-text">The release time in milliseconds.</div>
            </div>

            <div class="input-container">
              <label>Threshold</label>
              <input type="text" v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].compressor.threshold" />
              <div class="help-text">Compression threshold in dB.</div>
            </div>
            
            <div class="input-container">
              <button class="button-small" type="button" @click="saveAudioServerEffect('compressor')">Apply Compressor Settings</button>
            </div>

          </div>

        </div>


        <div class="input-group" id="SettingsLimiter" v-if="view('limiter')">

          <h2>Limiter</h2>

          <div v-if="Settings.audioServer && Settings.audioServer.instances && Settings.audioServer.instances[instance.name] && Settings.audioServer.instances[instance.name].outputs['device-1'] && Settings.audioServer.instances[instance.name].outputs['device-1'].limiter">

            <div class="input-container">
              <label>Ceiling (decimal, dB)</label>
              <input type="text" v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].limiter.ceiling" />
              <div class="help-text">The maximum level allowed.</div>
            </div>

            <div class="input-container">
              <label>Link Channels</label>
              <select v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].limiter.linkChannels">
                <option :value="true">On</option>
                <option :value="false">Off</option>
              </select>
              <div class="help-text">Links the left and right channels together when "on". When "off" it functions as two mono limiters.</div>
            </div>

            <div class="input-container">
              <label>Release Time</label>
              <input type="text"  v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].limiter.releaseTime" />
              <div class="help-text">The release time in milliseconds. Higher values make the limiter more transparent.</div>
            </div>

            <div class="input-container">
              <label>Threshold (decimal, dB)</label>
              <input type="text" v-model="Settings.audioServer.instances[instance.name].outputs['device-1'].limiter.threshold" />
              <div class="help-text">Reducing this value without reducing the ceiling by the same amount will drive the limiter harder, and increase the volume.</div>
            </div>

            <div class="input-container">
              <button class="button-small" type="button" @click="saveAudioServerEffect('limiter')">Apply Limiter Settings</button>
            </div>

          </div>

        </div>

        <!-- ================================================ -->

        <div class="input-group" v-if="view('crossfades')">
          
          <h2>Crossfades</h2>

          <div class="input-container">
            <label>Preview Filename</label>
            <input type="text" v-model="peaksPreviewFilenameWithoutExt" />
            <div class="help-text">Filename <b>without</b> the ".mp3" -- Example: <b>97287</b></div>
          </div>

          <div id="peaks-container">
            <div id="peaks-zoomview-container"></div>
            <div id="peaks-overview-container"></div>
          </div>

          <!-- <div :style="{display: crossfadePeakInstance ? 'block' : 'none' }"> -->

            <audio v-if="peaksAudioTagURL" :style="{display: crossfadePeakInstance ? 'block' : 'none' }" controls id="peaks-audio">
              <!-- !!! NO-ZONE-LIBRARY -->
              <source :src="peaksAudioTagURL" type="audio/mpeg">
            </audio>
          <!-- </div> -->
          
          <br>

          <button @click="testCrossfades" class="button-small" type="button">Preview Crossfades</button>

          <br>
          <br>

          <h3>Volume Thresholds</h3>

          <div class="input-container">
            <label>Cue</label>
            <input type="text" v-model="Settings.instances[instance.name].crossfades.startThreshold" />
            <div class="help-text">Range: from 1 to 100. (Default: 2) &mdash; Audio level at which it cues this track.</div>
          </div>

          <div class="input-container">
            <label>Segue</label>
            <input type="text" v-model="Settings.instances[instance.name].crossfades.endThreshold" />
            <div class="help-text">Range: from 1 to 100. (Default: 2) &mdash; Audio level at which it cues the next track.</div>
          </div>

          <h3>Fade Durations</h3>

          <div class="input-container">
            <label>Fade In</label>
            <input type="text" v-model="Settings.instances[instance.name].crossfades.durationOfFadeIn" />
            <div class="help-text">Seconds (Default: 0.01) &mdash; Duration of fade in.</div>
          </div>

          <div class="input-container">
            <label>Fade Out</label>
            <input type="text" v-model="Settings.instances[instance.name].crossfades.durationOfFadeOut" />
            <div class="help-text">Seconds (Default: 0.01) &mdash; Duration of fade out.</div>
          </div>

          <h3>Levels</h3>

          <div class="input-container">
            <label>Default (Faded In)</label>
            <input type="text" v-model="Settings.instances[instance.name].crossfades.levelDefault" />
            <div class="help-text">Range from 0.0 to 1.0 (Default: 1) &mdash; Normal level of audio. 1.0 is full volume, 0.0 is silent.</div>
          </div>

          <div class="input-container">
            <label>Silent (Faded Out)</label>
            <input type="text" v-model="Settings.instances[instance.name].crossfades.levelSilent" />
            <div class="help-text">Range from 0.0 to 1.0 (Default: 0) &mdash; Level of audio when faded out. 1.0 is full volume, 0.0 is silent.</div>
          </div>

          <div class="input-container">
            <button class="button-small" type="button" @click="applyCrossfades()">Apply Crossfade Settings</button>
          </div>
  
        </div>

        <div class="input-group input-group-wide" v-if="view('carts')">

          <h2>Carts</h2>

          <hr>

          <!-- <h3>Main Cart Folder</h3> -->

          <div class="input-container">
            <!-- 
            <label>Path</label>
            <input type="text" class="lg" v-model="Settings.instances[instance.name].carts.path" /> 
            <div class="help-text">Path to the carts folder.</div>
            -->
            Carts Location: <b v-if="Settings.instances && Settings.instances[instance.name] && Settings.instances[instance.name].playlists" v-text="Settings.instances[instance.name].carts.path"></b>
          </div>
          
          <hr>

          <h3>Volume and Effects</h3>

          <div class="input-container">
            <label>Delay before start</label>
            <input type="text" v-model="Settings.instances[instance.name].carts.delaySecondsBeforeStart" />
            <div class="help-text">Wait time (in seconds) before it starts the cart <b>after</b> fading out the main music.</div>
          </div>

          <div class="input-container">
            <label>Volume of music</label>
            <input type="text" v-model="Settings.instances[instance.name].carts.volumeOfOverlappedAudio" />
            <div class="help-text">Volume of faded-down music. (From 0.0 to 1.0)</div>
          </div>

          <h3>Cart Commands</h3>

          <table v-if="Settings.instances[instance.name].commands" class="table-wide">
            <thead>
              <th></th>
              <th>Type</th>
              <th>Path</th>
            </thead>
            <tbody>
              <tr v-for="(command, commandKey, index) in Settings.instances[instance.name].commands">
                <td>
                  <button type="button" class="button-small" @click="triggerCommand(Settings.instances[instance.name].commands[commandKey].command)">Start</button>
                </td>
                <td>
                  <select class="block" v-model="Settings.instances[instance.name].commands[commandKey].command">
                    <option value="**CM01">Main 1</option>
                    <option value="**CM02">Main 2</option>
                    <option value="**CM03">Main 3</option>
                    <option value="**CM04">Main 4</option>
                    <option value="**CM05">Main 5</option>
                    <option value="**CM06">Main 6</option>
                    <option value="**CM07">Main 7</option>
                    <option value="**CM08">Main 8</option>
                    <option value="**CM09">Main 9</option>
                    <option value="**CM00">Main 0</option>
                    <option value="**CS01">Shift + 1</option>
                    <option value="**CS02">Shift + 2</option>
                    <option value="**CS03">Shift + 3</option>
                    <option value="**CS04">Shift + 4</option>
                    <option value="**CS05">Shift + 5</option>
                    <option value="**CS06">Shift + 6</option>
                    <option value="**CS07">Shift + 7</option>
                    <option value="**CS08">Shift + 8</option>
                    <option value="**CS09">Shift + 9</option>
                    <option value="**CS00">Shift + 0</option>
                    <option value="**CC01">CTRL + 1</option>
                    <option value="**CC02">CTRL + 2</option>
                    <option value="**CC03">CTRL + 3</option>
                    <option value="**CC04">CTRL + 4</option>
                    <option value="**CC05">CTRL + 5</option>
                    <option value="**CC06">CTRL + 6</option>
                    <option value="**CC07">CTRL + 7</option>
                    <option value="**CC08">CTRL + 8</option>
                    <option value="**CC09">CTRL + 9</option>
                    <option value="**CC00">CTRL + 0</option>
                    <option value="**CA01">ALT + 1</option>
                    <option value="**CA02">ALT + 2</option>
                    <option value="**CA03">ALT + 3</option>
                    <option value="**CA04">ALT + 4</option>
                    <option value="**CA05">ALT + 5</option>
                    <option value="**CA06">ALT + 6</option>
                    <option value="**CA07">ALT + 7</option>
                    <option value="**CA08">ALT + 8</option>
                    <option value="**CA09">ALT + 9</option>
                    <option value="**CA00">ALT + 0</option>
                    <option value="0:*OM01">OM 01</option>
                    <option value="0:*OM02">OM 02</option>
                    <option value="0:*01">Timed (01)</option>
                    <option value="0:*02">Timed (02)</option>
                    <option value="0:*03">Timed (03)</option>
                    <option value="0:*04">Timed (04)</option>
                    <option value="0:*05">Timed (05)</option>
                    <option value="0:*06">Timed (06)</option>
                    <option value="0:*07">Timed (07)</option>
                    <option value="0:*08">Timed (08)</option>
                    <option value="0:*09">Timed (09)</option>
                    <option value="900: 15 MIN BREAK NOTE">15m BN</option>
                  </select>
                </td>
                <td>
                  <select class="block" v-model="Settings.instances[instance.name].commands[commandKey].path">
                    <option v-for="path in Settings.instances[instance.name].carts.files" :value="path" v-text="path"></option>
                  </select>
                </td>
                <td>
                  <input class="block" type="text" :value="command.name">
                </td>
              </tr>
            </tbody>
          </table>

          <br>

          <button type="button" class="button-small" @click="addCommandToList()">Add Cart</button>
          
        </div>

        <div class="input-group" v-if="view('system')">

          <h2>System</h2>

          <div class="input-container" v-if="typeof Settings.debug.level != 'undefined'">
            <label>Debug Mode</label>
            <select v-model="Settings.debug.level">
              <option :value="0">Disabled</option>
              <option :value="1">Enabled</option>
            </select>
            <div class="help-text">Enables extra logging info to help debug issues.</div>
          </div>

        <!--
          <h2>Deployment</h2>

          <div class="input-container">
            <button class="button-small" type="button" @click="restartDevice()">Reload System Config</button>
            <div class="help-text">Downloads system-level settings from the central device manager platform.</div>
            <div class="help-text">Settings include: timezone</div>
          </div>
        -->

        </div>

        <!-- ================================================ -->
      
      </div>
      </div>

    </form>

  </div>
</template>

<script>

import axios from 'axios';
import moment from 'moment';
import jQuery from 'jquery';

import Peaks from 'peaks.js'

let $ = jQuery

// Icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'page-settings-editor',
  props: ['instance', 'config', 'remote-control-target'],
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      Settings: null,
      systemStatus: null,
      UI: {
        sidebarLinks: [
          'home', 
          'library', 
          'playlists', 
          'carts', 
          'compressor',
          'limiter', 
          'crossfades', 
          'system', 
          'restart',  
        ],
        view: 'home'
      },
      songHistoryDate: null,
      songHistoryList: [],
      loading: false,
      crossfadePeakInstance: null,
      peaksPreviewFilenameWithoutExt: null,
      peaksAudioTagURL: null,
      refreshSystemStatusInterval: null,
    }
  },
  computed: {

  },
  methods: {
    getCurrentDate(){
      const date = moment().format('YYYY-MM-DD')
      return date
    },
    setLoading(value){
      let parentThis = this
      if(value == false){
        setTimeout(function(){
          parentThis.loading = false
        }, 1000)
      }
    },
    updateView(view){
      this.UI.view = view;
    },
    view(view){
      return this.UI.view == view
    },
    saveSettings(){

      const parentThis = this;
      parentThis.loading = true

      axios
        .patch(
          `${this.config.address}/settings`, 
          { settings: parentThis.Settings }
        )
        .then((response) => {
          parentThis.setLoading(false)
          // parentThis.refreshAPI();
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });

    },
    replaceInstanceName(input) {
      return input.replace(/{instanceName}/, this.instance.name);
    },

    scanLibraryFast() {
      const parentThis = this;
      parentThis.loading = true
      axios
        .post(`${this.config.address}/scan/library/fast`, { i: this.instance.name })
        .then((response) => {
          parentThis.setLoading(false)
          // parentThis.refreshAPI();
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });
    },
    scanLibrary() {
      const parentThis = this;
      parentThis.loading = true
      axios
        .post(`${this.config.address}/scan/library`, { i: this.instance.name })
        .then((response) => {
          parentThis.setLoading(false)
          // parentThis.refreshAPI();
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });
    },

    refreshTimeline(){
      
      const parentThis = this;

      axios
        .patch(this.config.address + '/timeline', {
          i: this.instance.name, 
          date: moment().format('YYYY-MM-DD')
        })
        .then((response) => {
          // parentThis.refreshAPI();
        })
        .catch((error) => {
          // console.log(error);
        });

    }, 
    playlistsScanToday(){
      
      const parentThis = this;

      axios
        .post(this.config.address + '/scan/playlists', {
          i: this.instance.name, 
          startDate: moment(this.instance.timeline.dateStart),
          endDate: moment(this.instance.timeline.dateEnd)
        })
        .then((response) => {
          // parentThis.refreshAPI();
        })
        .catch((error) => {
          console.log(error);
        });

    },

    getSongHistoryForDay(dateString){
      
      const parentThis = this;

      parentThis.loading = true

      const URL = `https://ambiance.cloud/api/tracks/by-guid-and-date/${this.instance.meta.GUID}/${this.songHistoryDate}`

      axios
        .get(URL)
        .then((response) => {

          parentThis.songHistoryList = response.data.data
          
          parentThis.loading = false

        })
        .catch((error) => {
          console.log(error);
        });

    },

    rebootDevice() {
      const parentThis = this;
      // console.log(this.instance)
      parentThis.loading = true
      axios
        .post(`${this.config.address}/system/reboot`, { i: this.instance.name })
        .then((response) => {
          parentThis.setLoading(false)
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });
    },

    restartAudioServer() {
      const parentThis = this;
      // console.log(this.instance)
      parentThis.loading = true
      axios
        .post(`${this.config.address}/system/audio-server/restart`, { i: this.instance.name })
        .then((response) => {
          parentThis.setLoading(false)
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });
    },

    restartAutomationServer() {
      const parentThis = this;
      // console.log(this.instance)
      parentThis.loading = true
      axios
        .post(`${this.config.address}/system/automation-server/restart`, { i: this.instance.name })
        .then((response) => {
          parentThis.setLoading(false)
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });
    },

    saveAudioServerEffect(effectType) {

      const parentThis = this;

      const url = `${this.config.address}/audio-server/effects`

      const effectParameters = parentThis.Settings.audioServer.instances[this.instance.name].outputs['device-1'][effectType]

      console.log("Horse")
      console.log(effectParameters)
      console.log(url)

      parentThis.loading = true

      axios
        .patch(url, { 
          i: this.instance.name, 
          effectType,
          effectParameters
        })
        .then((response) => {
          parentThis.setLoading(false)
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });

    },

    saveAudioServerChannels() {

      const parentThis = this;

      const url = `${this.config.address}/audio-server/instances/${this.instance.name}/outputs/device-1`

      const channels = this.Settings.audioServer.instances[this.instance.name].outputs['device-1'].channels

      let channelsAsIntegers = []

      // AudioServer requires that they are integers
      for (var c = 0; c < channels.length; c++) {
        channelsAsIntegers[c] = parseInt(channels[c])
      }

      console.log(url)
      console.log(channels)

      parentThis.loading = true

      axios
        .patch(url, { 
          channels: channelsAsIntegers
        })
        .then((response) => {
          parentThis.setLoading(false)
          // parentThis.refreshAPI();
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });

      // Post to log
      axios
        .post(`${this.config.address}/webhook/log`, { 
          instanceName: parentThis.instance.name,
          message: `AudioServer: Updated output settings.`,
          type: 'info',
        })
        .then((response) => {
          parentThis.setLoading(false)
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });

    },

    refreshSettings(){

      const parentThis = this;

      // parentThis.loading = true

      axios
        .get(`${this.config.address}/settings`)
        .then((response) => {
          parentThis.Settings = response.data.data || null
          // console.log(response.data.data || null)
        })
        .catch((error) => {
          console.log(error);
        });
        
    },

    refreshLibraryClientSettings(){

      const parentThis = this;

      // parentThis.loading = true
      axios
        .get(`${this.config.addresses.libraryClient}`)
        .then((response) => {
          parentThis.libraryClient = response.data || null
          // console.log(response.data || null)
        })
        .catch((error) => {
          console.log(error);
        });
        
    },
    
    refreshSystemStatus(){

      const parentThis = this;
      
      // parentThis.loading = true

      axios
        .get(`${this.config.address}/system`)
        .then((response) => {
          parentThis.systemStatus = response.data.data || null
          // console.log(response.data.data || null)
        })
        .catch((error) => {
          console.log(error);
          // parentThis.setLoading(false)
        });
        
    },
    bytesToSize(bytes) {
       var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
       if (bytes == 0) return '0 Byte';
       var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
       return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
    triggerCommand(commandString) {

      const parentThis = this;

      const url = `${this.config.address}/commands`

      parentThis.loading = true

      axios
        .post(url, { 
          instanceName: parentThis.instance.name,
          command: commandString
        })
        .then((response) => {
          parentThis.setLoading(false)
        })
        .catch((error) => {
          parentThis.setLoading(false)
        });

    },
    addCommandToList() {
      
      let C = this.Settings.instances[this.instance.name].commands;

      const commandToClone = JSON.parse(JSON.stringify( C[0] ))
      
      C = C.push(commandToClone)

    },
    createPeaks() {

      const peakOptions = {

        containers: {
          zoomview: document.getElementById('peaks-zoomview-container'),
          overview: document.getElementById('peaks-overview-container')
        },

        // HTML5 Media element containing an audio track
        mediaElement: document.getElementById('peaks-audio'),
        
        dataUri: {
          // arraybuffer: '../test_data/sample.dat',
          json: (
            `${this.config.address}`
            + `/filesystem/waveforms/${this.instance.name}/${this.peaksPreviewFilenameWithoutExt}.json`
          ),
        },

      }

      this.crossfadePeakInstance = Peaks.init(peakOptions, function(err, peaks) {
        // ...
      })

    },
    getCrossfades(callback) {

      let parentThis = this

      const postData = {
        i: this.instance.name,
        id: this.peaksPreviewFilenameWithoutExt,
        start: this.Settings.instances[this.instance.name].crossfades.startThreshold,
        end: this.Settings.instances[this.instance.name].crossfades.endThreshold,
      }

      const URL = `${this.config.address}/crossfades`

      this.setLoading(false)

      const response = axios
        .post(URL, postData)
        .then((response) => {
          callback(response.data.data)
          parentThis.setLoading(false)
        })
        .catch((error) => {
          parentThis.setLoading(false)
        })

      // console.log(response)

    },
    drawCrossfadesOnPeaks(crossfades){

      // console.log("WOOOOP")
      console.log(crossfades)

      // this.crossfadePeakInstance.points.removeAll() 

      // console.log("asiufdahief")

      const startTime = parseFloat(crossfades.crossfade_start)
      const endTime = parseFloat(crossfades.crossfade_end)

      console.log(startTime)
      console.log(endTime)

      // console.log(this.crossfadePeakInstance.points)

      console.log(this.crossfadePeakInstance.points.getPoints())

      // this.crossfadePeakInstance.points.add({
      //   // time: 3.5, 
      //   time: startTime, 
      //   // editable: false, 
      //   // color: '#ff0000', 
      //   // labelText: "Start", 
      //   // id: 1,
      // })

      // console.log(726674286734)

      this.crossfadePeakInstance.points.add([
        {
          time: startTime, 
          // editable: false, 
          color: '#ff0000', 
          labelText: "Crossfade Start", 
          // id: 1,
        },
        {
          time: endTime, 
          // editable: false, 
          color: '#ff0000', 
          labelText: "Crossfade End", 
          // id: 2,js decimal and flot difference
        }
      ])

      console.log("ADDDDDDDED")

    },
    testCrossfades() {

      let parentThis = this

    //       if(this.crossfadePeakInstance && this.crossfadePeakInstance.destroy){
    //   this.crossfadePeakInstance.destroy();
    // }
      // HACK: Delay setting the audio URL so that it is re-rendered.
      // this.peaksAudioTagURL = null  

      const newAudioURL = `${this.config.address}/filesystem/library/${this.peaksPreviewFilenameWithoutExt}.mp3`

      if(parentThis.peaksAudioTagURL != newAudioURL){
        console.log("NEW AUDIO FILE")
        if(this.crossfadePeakInstance && this.crossfadePeakInstance.destroy){
          this.crossfadePeakInstance.destroy();
          console.log("DESTROYED PEAKS")
        }
        parentThis.peaksAudioTagURL = null
        console.log("AUDIO NULLED")
      }

      // if(this.crossfadePeakInstance && this.crossfadePeakInstance.destroy){
      //   this.crossfadePeakInstance.destroy();
      // }

      setTimeout(() => {
        
        this.peaksAudioTagURL = newAudioURL
        
        setTimeout(() => {

          parentThis.createPeaks()

          parentThis.getCrossfades((crossfades) => {

            parentThis.drawCrossfadesOnPeaks(crossfades)
          
          })

        }, 200)

      }, 200)

    },
    applyCrossfades() {
      const parentThis = this;
      // parentThis.loading = true
      
      const postData = {
        i: this.instance.name,
        start: this.Settings.instances[this.instance.name].crossfades.startThreshold,
        end: this.Settings.instances[this.instance.name].crossfades.endThreshold,
      }

      axios
        .post(
          `${this.config.address}/scan/crossfades`, 
          postData
        )
        .then((response) => {
          // parentThis.setLoading(false)
        })
        .catch((error) => {
          // parentThis.setLoading(false)
        })
    },
  },
  created() {

    this.getCurrentDate()
    this.refreshSettings();
    this.refreshLibraryClientSettings();
    this.refreshSystemStatusInterval = setInterval(this.refreshSystemStatus, 1000);

    // $(document, 'button').on('click', function(){
    //   this.addClass('pressed')
    //   setTimeout(function(){
    //     this.removeClass('pressed')
    //   }, 500)
    // })

  },
  beforeDestroy() {
    
    if(this.crossfadePeakInstance && this.crossfadePeakInstance.destroy){
      this.crossfadePeakInstance.destroy();
    }
    
    clearInterval(this.refreshSystemStatusInterval)

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


<style lang="stylus" scoped>

  .settings-header-spacer 
    height 110px
  

  .sidebar
    float left
    height 650px
    width 20%
    // background #f9f9f9
    // box-shadow 0 4px 8px rgba(0,0,0,.1)

    a
      display block
      padding 12px 40px
      margin-bottom 4px
      color #555
      font-size 20px
      border-radius 6px
      margin-left -8px
      text-align right
      text-decoration none
      text-transform capitalize
      
      &:hover
        color #000

      &.selected
        background #fff
        box-shadow 0 4px 8px rgba(0,0,0,.1)

  hr
    margin 30px 0
    border 1px solid #ddd
    
  h1 
    margin 10px 0 10px 0
    font-size 28px
  
  h2 
    margin 0 0 20px 0
    font-size 22px
      
  h3
    margin 20px 0 20px 0
    font-size 18px

  form
    padding 0px

  .table-wide
    width: 100%
    
    td 
      padding 5px
  
  input.lg
    width: 350px
    padding: 10px
    font-size: 15px
    
  input.sm
    width: 70px
    padding: 10px
    font-size: 15px

  input.block
    width: 100%
    box-sizing border-box
    padding: 10px
    font-size: 15px

  select.block
    width: 100%
    box-sizing border-box
    padding: 10px 10px
    font-size: 15px

  .loading
    display block
    padding 10px
    font-size 30px
    color #888

  .loading-status
    color #888
    font-size 30px
    opacity 1
    transition all 0.3s
    float right
    display block
    margin 8px 30px 0 0

  .loading-status-faded
    transition all 0.2s
    opacity 0

  .input-page
    float left
    width 80%
    padding 0px 0px 0px 0px
    // background #ddd
    
  .input-page-inner
    padding 0 40px 0 40px

  .input-group
    
    display inline-block
    width 100%
    margin 0 20px 20px 0
    box-sizing border-box
    // border 1px solid rgba(0,0,0,.1)
    box-shadow 0 2px 6px rgba(0,0,0,.15)
    padding 40px
    vertical-align top
    border-radius 3px
    background #fff
    // background rgba(0,0,0,.05)

    section
      display inline-block
      margin 0 10px 10px 0
      vertical-align top
      width 45%
      min-width 300px
  
  .input-group-half-wide

    width 47%

  .help-text
    font-size 14px
    color #999
    margin 20px 0 8px 0
    line-height: 150%

  .input-container
    
    margin 0 20px 10px 0
    display block
    vertical-align top
    padding 10px 0
    // margin 0 0 0px 0
    
    label
      margin-right 8px 

    input, select
      border 1px solid #bbb
      background #fff
      font-size 16px
      padding 8px 10px
      border-radius 3px
    
  .submit-container
    padding 40px 40px 10px 40px
    // margin -20px
    margin-top -20px
    background #f3f3f3
    box-shadow 0 0 12px rgba(0,0,0,.4)
    // background rgba(0,0,0,.1)
    position fixed
    width 100%
    box-sizing border-box
    z-index 10
    
    button
      border 0
      // border 1px solid #bbb
      float right
      font-weight bold
      font-size 24px
      padding 10px 18px
      

  button
    padding 10px 18px
    border-radius 5px
    font-size 24px
    color #fff
    // color #444
    // background #fff
    background #4c984a
    // box-shadow 0 2px 8px rgba(0,0,0,.2);
    box-shadow inset 0 -2px 0 rgba(0,0,0,.2);
    // border 1px solid #fff
    // font-weight bold
    transition all 0.5s
    border 0

    &:hover
      // background #fdfdfd
      box-shadow inset 0 -2px 0 rgba(0,0,0,.2), 0 3px 12px rgba(0,0,0,.3);
      cursor pointer
      
    &:active, &:focus
      outline none
      transition all 0.1s

    // svg
    //   margin-right
    
  button.button-small
    // border 1px solid #bbb
    // border-bottom-color #fff
    padding 10px 18px
    font-size 18px
    // background #fff
    // border 3px solid #4c984a
    // color #4c984a
    // box-shadow none
    
    &:hover
      background #65a856
      // background #65a856
      color #fff
      // box-shadow 0 2px 12px rgba(0,0,0,.3);
      transition all 0.3s

    &:active
    
      animation button-press 0.5s
      

  @keyframes button-press {
  
    0% {
      // margin-top 5px !important
      // padding 12px 18px 8px 18px !important
      box-shadow none
      // margin-bottom -2px !important
    }
    
    100% {
      // margin-top 0 !important
      // padding 10px 18px 10px 18px !important
      box-shadow inset 0 -2px 0 rgba(0,0,0,.2), 0 3px 12px rgba(0,0,0,.3)
      // margin-bottom 0 !important
    }
  
  }


</style>
